/**
 * DataTableMUI — wrapper mỏng quanh MUI X DataGrid với theme N2NAI.
 * Mọi page dùng grid đều đi qua đây để chuẩn hoá look & feel.
 */
import { Box } from '@mui/material'
import {
  DataGrid,
  type DataGridProps,
  type GridColDef,
  type GridRowsProp,
} from '@mui/x-data-grid'

export interface DataTableMUIProps<R extends Record<string, unknown> = Record<string, unknown>>
  extends Omit<DataGridProps, 'rows' | 'columns'> {
  rows: GridRowsProp<R>
  columns: GridColDef<R>[]
  height?: number | string
}

export function DataTableMUI<R extends Record<string, unknown> = Record<string, unknown>>({
  rows,
  columns,
  height = 560,
  ...rest
}: DataTableMUIProps<R>) {
  return (
    <Box sx={{ width: '100%', height }}>
      <DataGrid
        rows={rows}
        columns={columns as GridColDef[]}
        disableRowSelectionOnClick
        density="compact"
        pageSizeOptions={[10, 25, 50, 100]}
        sx={{
          backgroundColor: (t) => t.palette.background.paper,
          borderRadius: 1,
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: (t) => t.palette.action.hover,
          },
        }}
        {...rest}
      />
    </Box>
  )
}

export default DataTableMUI
